/* Carnitine page behaviour: jump links, the review carousel, and the plan picker's
   add-to-cart. Every carnitine-* section loads this file, and a <script src> runs once
   per tag, so the guard keeps the listeners from stacking up.

   The two cart messages are read off the picker element rather than from Liquid, because
   a file in assets/ is not rendered by the section that uses it. */

if (!window.__carnitinePage) {
  window.__carnitinePage = true;

  document.querySelectorAll('[data-carnitine-cta]').forEach(function (link) {
    var target = document.querySelector('[id^="MainProduct-"]');
    if (target) link.setAttribute('href', '#' + target.id);
  });
  // Jump to the customer voices / reviews section. Degrades to no-op rather than a dead anchor.
  document.querySelectorAll('[data-carnitine-reviews]').forEach(function (link) {
    var widget = document.getElementById('carnitine-customer-voices') ||
                 document.getElementById('judgeme_product_reviews') ||
                 document.querySelector('[class*="judgeme"], [id*="judge_me"]');
    if (!widget) return;
    link.setAttribute('href', '#' + widget.id);
  });
  // The GemPages CRO app (gp-global.js) attaches its own click handler to every in-page
  // anchor, calls preventDefault() and then never moves the page — so every jump link on
  // this page was dead. Run first, in the capture phase, and stop the event there.
  document.addEventListener('click', function (event) {
    var node = event.target instanceof Element ? event.target : event.target.parentElement;
    var link = node && node.closest ? node.closest('[data-carnitine-cta],[data-carnitine-reviews]') : null;
    if (!link) return;
    var id = (link.getAttribute('href') || '').replace(/^#/, '');
    var target = id ? document.getElementById(id) : null;
    if (!target) target = document.querySelector('[id^="MainProduct-"]');
    if (!target) return;
    event.preventDefault();
    event.stopPropagation();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, true);
  // The review carousel. Both handlers are bound to document and look the carousel up when
  // the event fires, rather than being attached to the buttons once at load. The theme
  // editor re-renders a section through the Section Rendering API, which replaces this
  // markup without re-running this file — a listener bound to the old button goes with it,
  // and the arrows stop responding until the page is reloaded. Replacing a review photo in
  // the editor is enough to hit it.
  var syncDots = function (wrap) {
    var dots = document.querySelectorAll('.carn-rev-dot');
    if (!dots.length) return;
    var max = wrap.scrollWidth - wrap.clientWidth;
    if (max <= 0) return;
    var idx = Math.min(dots.length - 1, Math.round((wrap.scrollLeft / max) * (dots.length - 1)));
    dots.forEach(function (dot, i) { dot.classList.toggle('active', i === idx); });
  };
  // A scroll event does not bubble, but it still reaches ancestors on the way down.
  document.addEventListener('scroll', function (event) {
    var wrap = event.target;
    if (wrap && wrap.classList && wrap.classList.contains('carn-rev-scroll-wrapper')) syncDots(wrap);
  }, true);

  var getCardIndex = function (wrap) {
    var figures = wrap.querySelectorAll('figure');
    if (!figures.length) return 0;
    var wrapCenter = wrap.scrollLeft + wrap.clientWidth / 2;
    var closestIdx = 0;
    var minDiff = Infinity;
    figures.forEach(function (fig, idx) {
      var figCenter = fig.offsetLeft + fig.offsetWidth / 2;
      var diff = Math.abs(wrapCenter - figCenter);
      if (diff < minDiff) {
        minDiff = diff;
        closestIdx = idx;
      }
    });
    return closestIdx;
  };

  // The arrows centre themselves on the picture. Looked up fresh each time, so a
  // re-rendered carousel gets them back too.
  var placeArrows = function () {
    var container = document.querySelector('.carn-rev-carousel-container');
    var wrap = container && container.querySelector('.carn-rev-scroll-wrapper');
    var photo = wrap && wrap.querySelector('.carn-rev-card__photo');
    if (!photo) return;
    var y = (photo.getBoundingClientRect().top - container.getBoundingClientRect().top)
          + photo.getBoundingClientRect().height / 2;
    if (y <= 0) return;
    container.querySelectorAll('.carn-rev-nav-btn').forEach(function (btn) {
      btn.style.top = Math.round(y) + 'px';
    });
  };
  window.addEventListener('resize', placeArrows, { passive: true });
  window.addEventListener('load', placeArrows, { passive: true });
  setTimeout(placeArrows, 60);
  setTimeout(placeArrows, 300);
  setTimeout(placeArrows, 1000);

  document.addEventListener('click', function (event) {
    var node = event.target instanceof Element ? event.target : event.target.parentElement;
    var btn = node && node.closest ? node.closest('.carn-rev-nav-btn') : null;
    if (!btn) return;
    var container = btn.closest('.carn-rev-carousel-container');
    var wrap = container && container.querySelector('.carn-rev-scroll-wrapper');
    if (!wrap) return;
    event.preventDefault();
    placeArrows();
    var figures = wrap.querySelectorAll('figure');
    if (!figures.length) return;
    var step = btn.classList.contains('carn-rev-nav-btn--prev') ? -1 : 1;
    var target = Math.max(0, Math.min(figures.length - 1, getCardIndex(wrap) + step));
    figures[target].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
  }, true);

  // Appstle's progressive-gift header ships "We value commitment / 2,3 packs? Get our free
  // rewards here" out of the app's own settings, which the theme cannot render. The wording
  // is rewritten here instead. Both writes are guarded so the observer cannot loop on its
  // own output, and the widget is watched rather than read once because Appstle injects it
  // after this file runs and rebuilds it whenever the tier changes.
  // Move this to the Appstle app — Volume Discounts, Progressive gifts, title — and the
  // block can go.
  (function () {
    var TITLE = 'Your stack comes with:';
    var fix = function () {
      var title = document.querySelector('.ab-volume-discount-progressive-gifts-header-title');
      if (title && title.textContent.trim() !== TITLE) title.textContent = TITLE;
      var sub = document.querySelector('.ab-volume-discount-progressive-gifts-header-subtitle');
      if (sub && sub.textContent !== '') sub.textContent = '';
    };
    fix();
    new MutationObserver(fix).observe(document.body, { childList: true, subtree: true });
  })();

  (function () {
    var offer = document.querySelector('[data-carn-offer]');
    if (!offer || offer.dataset.initialized === 'true') return;
    offer.dataset.initialized = 'true';

    var cards = [].slice.call(offer.querySelectorAll('[data-offer-card]'));
    var button = offer.querySelector('[data-cart-submit]');
    var status = offer.querySelector('[data-cart-status]');
    var defaultCta = button.textContent;
    var busyMessage = offer.dataset.busy || 'Adding…';
    var errorMessage = offer.dataset.error || 'Sorry — that option could not be added. Please pick another.';
    var busy = false;

    var selectedCard = function () {
      for (var i = 0; i < cards.length; i++) { if (cards[i].querySelector('input').checked) return cards[i]; }
      return null;
    };

    var setStatus = function (message, state) {
      if (!status) return;
      status.textContent = message || '';
      status.dataset.state = state || '';
    };

    var updateSelection = function () {
      var selected = selectedCard();
      cards.forEach(function (card) { card.classList.toggle('is-selected', card === selected); });
      if (!selected) return;
      button.disabled = busy;
      button.textContent = busy ? busyMessage : (selected.dataset.cta || defaultCta);
      if (!busy) setStatus('', '');
    };

    cards.forEach(function (card) {
      card.querySelector('input').addEventListener('change', updateSelection);
      card.addEventListener('click', function () {
        var radio = card.querySelector('input');
        if (!radio.checked) { radio.checked = true; updateSelection(); }
      });
    });

    // Appstle renders the same ladder as .ab-volume-discount-item-1, -2, -3, in the same
    // order, and takes the click on the container itself. Adding through it is the only way
    // to get the tier's discount and its gifts — a direct /cart/add is rewritten back to
    // whichever tier Appstle has selected.
    //
    // That container is a toggle, not a radio: clicking the tier that is already chosen
    // clears the bundle, the price reverts to one bottle at full price, and the gifts
    // disappear. Fire Stack ships as Appstle's own default, so this is not a rare path.
    // Only click a change.
    var chooseTier = function (index) {
      var tier = document.querySelector('.ab-volume-discount-item-' + index);
      if (!tier) return false;
      if (!tier.classList.contains('ab-volume-discount-item-selected')) tier.click();
      return true;
    };

    button.addEventListener('click', function () {
      if (busy) return;
      var selected = selectedCard();
      var addButton = document.querySelector('[id^="MainProduct-"] button[name="add"]');
      if (!selected) { setStatus(errorMessage, 'error'); return; }
      if (!chooseTier(cards.indexOf(selected) + 1) || !addButton) {
        setStatus(errorMessage, 'error');
        return;
      }
      busy = true;
      updateSelection();
      // Appstle re-prices and re-renders the buy box on its own click, so let it settle
      // before submitting. The reset is a safety net: the submit normally navigates away.
      setTimeout(function () { addButton.click(); }, 400);
      setTimeout(function () { busy = false; updateSelection(); }, 8000);
    });

    updateSelection();
  })();
}
